/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum InactivityAliases {
  ACTION_PANEL = 'action-panel',
  GO_TO_LOGIN_BUTTON = 'go-to-login-button',
  INACTIVITY_MESSAGE_TEXT = 'inactivity-message-text',
  MAIN_LAYOUT = 'main-layout',
}
export { InactivityAliases };
